import * as React from 'react'
import { Column } from '../types'

interface TextInputProps {
  column: Column
  value: string | number | string[] | number[] | null
  onChange: (value: string) => void
  fieldId: string
}

export default function TextInput({
  column,
  value,
  onChange,
  fieldId,
}: TextInputProps) {
  const currentValue = String(value ?? '')

  if (column.settings.multiline) {
    return (
      <textarea
        id={fieldId}
        className="form-control"
        value={currentValue}
        onChange={(e) => onChange(e.target.value)}
        required={column.required}
        rows={4}
      />
    )
  }

  return (
    <input
      id={fieldId}
      type="text"
      className="form-control"
      value={currentValue}
      onChange={(e) => onChange(e.target.value)}
      required={column.required}
    />
  )
}
